<template>
  <div class="app-container-v2 table-container-v2 has-tabs" v-loading="loading">
    <div class="title-box">
      <div class="title-left">
        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.handleStatus" collapse-tags :placeholder="$t('dealStatus')" filterable clearable>
            <el-option v-for="item in dictData.dealStatus" :key="item.id" :value="item.id" :label="item.text"/>
          </el-select>
        </div>
        <div class="select-v2" v-if="tabActive == 1">
          <el-select class="query-select" v-model="queryParams.perStatusType" collapse-tags :placeholder="$t('perStatusType')" filterable clearable>
            <el-option v-for="item in dictData.perStatusType" :key="item.id" :value="item.id" :label="item.text"/>
          </el-select>
        </div>

        <div class="date-picker-v2">
          <el-date-picker
            class="query-date-picker"
            v-model="wageMonthRange"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :range-separator="$t('rangeSeparator')"
            :start-placeholder="$t('from')"
            :end-placeholder="$t('to')"
            :clearable="false">
          </el-date-picker>
        </div>

        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.companyCode" collapse-tags :placeholder="$t('companyCode')" filterable clearable>
            <el-option v-for="item in dictData.companyCode" :key="item.id" :value="item.id" :label="item.text"/>
          </el-select>
        </div>
      </div>
      <div class="title-right">
        <div class="title-tips mr16">*导出处理成功状态的数据不包括取消入职人员</div>
        <el-button type="primary" class="button-v2" @click="handleSearch">{{ $t('query') }}</el-button>
        <el-button type="primary" class="button-v2" @click="handleExport">{{ $t('export') }}</el-button>
        <el-button type="primary" class="button-v2" @click="handleConfirm">{{ $t('confirm') }}</el-button>
      </div>
    </div>
    <div class="table-body">
      <el-tabs v-model="tabActive" type="card" @tab-click="handleClick">
        <el-tab-pane label="雇员数据" name="1"></el-tab-pane>
        <el-tab-pane label="雇员公司调整数据" name="2"></el-tab-pane>
        <el-tab-pane label="调薪数据" name="3"></el-tab-pane>
      </el-tabs>
      <div class="table-body-tabs-content flex vertical jbetween">
        <div class="table-body-table">
          <air-table
            ref="airTable"
            class="table-v2"
            :show-operation="false"
            align="center"
            :columns="columns"
            :data="tableData"
            @checkbox-change="handleSelectionChange"
            @checkbox-all="handleSelectionChange"
            @change-filter="changeFilter"
          ></air-table>
        </div>
        <bsp-pagination :pager-config.sync="pagerConfig" @page-change="getData" @page-size-change="pageSizeChange" show-page-size></bsp-pagination>
      </div>
    </div>
    <air-confirm-v2
      :show.sync="confirmShow"
      :title="confirmTitle"
      :content="confirmContent"
      :confirm-function="confirmFunction"
    ></air-confirm-v2>
  </div>
</template>

<script>
  import { validatenull } from '@/util/validate';
  import { queryTableColumns, queryCustomRecordData, exportCustomInfoExcel, exportCustomExcel, confirmHandleData } from "@/api/tesla/teslaCustomRecord";
  export default {
    name: "CustomRecord",
    created() {
      this.handleClick()
    },
    data() {
      return {
        render: true,
        loading: false,
        dictData: {
          dealStatus: [
            { id: '', text: '全部状态' },
            { id: '1111', text: '待处理' },
            { id: '0000', text: '处理成功' },
            { id: '9999', text: '处理失败' }
          ],
          perStatusType: [
            { id: '', text: '全部类型' },
            { id: 'add', text: '新入职' },
            { id: 'resignate', text: '离职' },
            { id: 'update', text: '信息变更' },
            { id: 'cancel', text: '取消入职' }
          ],
          companyCode: [
            { id: '', text: '全部公司' },
            { id: '1000', text: '特斯拉公司' },
            { id: '2000', text: '特斯拉（上海）有限公司' }
          ]
        },
        wageMonthRange: [],
        queryParams: {},
        pagerConfig: {
          page: 1,
          limit: 20,
          total: 0
        },
        tabActive: '1',
        columns: [],
        tableData: [],
        multiple: [],
        confirmShow: false,
        confirmTitle: '',
        confirmContent: '',
        confirmFunction: undefined
      }
    },
    methods: {
      handleClick(tab, event) {
        this.columns = []
        this.tableData = []
        this.queryParams = {}
        this.pagerConfig = {
          page: 1,
          limit: 20,
          total: 0
        }
        this.wageMonthRange = [
          this.$day().date(19).subtract(1, 'M').format('YYYY-MM-DD'), // 上个月19号
          this.$day().date(18).format('YYYY-MM-DD') // 本月18号
        ];
        this.multipleSelection = []
        this.getData()
      },
      handleSearch() {
        this.queryParams.page = 1
        this.queryParams.limit = 20
        this.getTableData()
      },
      handleSelectionChange({records}) {
        this.multipleSelection = records;
      },
      changeFilter(e) {
        this.pagerConfig.page = 1
        this.queryParams = {...this.queryParams, ...e.filterData}
        this.getTableData()
      },
      getData() {
        this.getColumns()
        this.getTableData()
      },
      // 获取表头
      getColumns(){
        const params = {
          methodFlag: this.tabActive
        }
        queryTableColumns(params).then(res => {
          const columns = [...res.data.data]
          columns.forEach(item => {
            item.minWidth = 140
            if (item.field === 'name' || item.field === 'idNumber' || item.field == 'employeeId') {
              item.fixed = 'left'
              item.filterType = 'input'
            }
          })
          this.columns = columns
        });
      },
      // 获取表格数据
      getTableData() {
        this.render = false
        this.loading = true
        const params = {
          ...this.getQueryParams
        }
        queryCustomRecordData(params).then(res => {
          this.render  = true
          this.loading = false
          const { data, total } = res.data.data
          this.pagerConfig.total = total;
          this.tableData = data
        })
      },
      // 导出
      handleExport() {
        const { handleStatus } = this.queryParams
        if (this.tabActive != "3") {
          if (validatenull(handleStatus)) {
            this.$message.error('请选择处理状态')
            return
          }
        }
        const exportFn = handleStatus == '0000' ? exportCustomInfoExcel : exportCustomExcel
        this.$msgInfo(`${ this.$t('startDownloading') }...`);
        const params = {
          ...this.getQueryParams
        }
        exportFn(params).then(res => {
          this.loading = false
          this.$downloadFile(res);
        })
      },
      // 确认
      handleConfirm() {
        if (validatenull(this.multipleSelection)) {
          this.$msgError('请选择确认人员')
          return
        }
        this.confirmShow = true
        this.confirmContent = '是否确认提交？'
        this.confirmFunction = () => {
          const tableIds = this.multipleSelection.map(item => item.customRecordId)
          const params = {
            methodFlag: this.tabActive,
            tableIds: tableIds.join(',')
          }
          confirmHandleData(params)
            .then(res => {
              let tips = '存在确认失败情况，请在页面查看原因！'
              const { executeFlag, tip } = res.data.data
              if (executeFlag === true) {
                this.$msgSuccess('确认成功')
              } else {
                tips = `${ tips }${ validatenull(tip) ? '' : tip }`
                this.$msgError(tips)
              }
              this.getTableData()
            });
          }
      }
    },
    computed: {
      getQueryParams() {
        const params = {
          ...this.queryParams,
          methodFlag: this.tabActive,
          ...this.pagerConfig
        }
        if (this.$isNotEmpty(this.wageMonthRange)) {
          params.startDate = this.wageMonthRange[0]
          params.endDate = this.wageMonthRange[1]
        } else {
          params.startDate = undefined
          params.endDate = undefined
        }
        return params
      }
    }
  };
</script>
